<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="eventNotFound">
  <div class="modal-header">
    <h4 class="modal-title">Event Not Found</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!(serverError || eventNotFound)">

  <div class="modal-header">
    <h4 class="modal-title">{{ isPrivate ? 'Cancel Private Event' : 'Cancel Event' }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="loadingEvent">
    <h3 class="text-muted">Loading...</h3>
  </div>

  <div class="modal-body" *ngIf="!loadingEvent && event">

    <p>
      <b>{{ event.event_type_name }}</b>
      <ng-container *ngFor="let eventPart of event.event_parts">
        <br>
        <b>
          {{ dayOfWeekStringFromISO8601(eventPart.start_datetime_isoformat) }},
          {{ dateStringFromISO8601(eventPart.start_datetime_isoformat) }},
          {{ timeStringFromISO8601(eventPart.start_datetime_isoformat) }} -
          {{ timeStringFromISO8601(eventPart.end_datetime_isoformat) }}
        </b>
      </ng-container>
    </p>

    <div *ngIf="event.event_parts.length > 1" class="alert alert-warning">
      This is a multi-part event.

      <span *ngIf="event.event_parts.length === 2">Both parts will be cancelled.</span>
      <span *ngIf="event.event_parts.length > 2">All {{ event.event_parts.length }} parts will be cancelled.</span>
    </div>

    <hr>

    <p *ngIf="event.num_reservations !== 1">
      There are <b>{{ event.num_reservations }} reservations</b> associated with this event.
    </p>
    <p *ngIf="event.num_reservations === 1">
      There is <b>1 reservation</b> associated with this event.
    </p>

    <!--
      Private event refund options (PRO-1229). Shown when the booking has an
      amount paid which has not been fully refunded, mirroring the options
      offered when cancelling a single public event booking.
    -->
    <ng-container *ngIf="isPrivate && hasRefundableAmount()">
      <hr>

      <p>There was a fee associated with this booking.</p>

      <div class="row mb-3">
        <div class="col-12">
          <div class="row mb-2">
            <div class="col-6">
              <h5 class="mb-0">
                {{ organizationConfigService.getCurrencySymbol() }}{{ booking.total_currency_amount|number:'.2' }}
                <ng-container *ngIf="booking.total_num_vouchers > 0">+ {{ booking.total_num_vouchers }} voucher(s)</ng-container>
              </h5>
              <span>Amount Paid</span>
            </div>
            <div class="col-6" *ngIf="(booking.refunded_currency_amount > 0) || (booking.refunded_num_vouchers > 0)">
              <h5 class="mb-0">
                {{ organizationConfigService.getCurrencySymbol() }}{{ booking.refunded_currency_amount|number:'.2' }}
                <ng-container *ngIf="booking.total_num_vouchers > 0">+ {{ booking.refunded_num_vouchers }} voucher(s)</ng-container>
              </h5>
              <span>Previously Refunded</span>
            </div>
          </div>
          <div class="row" *ngIf="(booking.refunded_currency_amount > 0) || (booking.refunded_num_vouchers > 0)">
            <div class="col-6">
              <h5 class="mb-0">
                {{ organizationConfigService.getCurrencySymbol() }}{{ booking.unrefunded_currency_amount|number:'.2' }}
                <ng-container *ngIf="booking.total_num_vouchers > 0">+ {{ booking.unrefunded_num_vouchers }} voucher(s)</ng-container>
              </h5>
              <span>Remaining Unrefunded</span>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <fieldset>
          <span>Refund Options *</span>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="refundSelection" required
                   id="refundOptionNo"
                   [value]="refundOptions.noRefund"
                   [(ngModel)]="refundSelection">
            <label class="form-check-label" for="refundOptionNo">No Refund</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="refundSelection" required
                   id="refundOptionPartial"
                   [value]="refundOptions.partialRefund"
                   [(ngModel)]="refundSelection">
            <label class="form-check-label" for="refundOptionPartial">Partial Refund</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="refundSelection" required
                   id="refundOptionFull"
                   [value]="refundOptions.fullRefund"
                   [(ngModel)]="refundSelection">
            <label class="form-check-label" for="refundOptionFull">Full Booking Refund</label>
          </div>
        </fieldset>

        <div class="row mt-2" *ngIf="refundSelection === refundOptions.partialRefund">
          <div class="col-12">
            <div class="row">
              <div class="col-6" *ngIf="booking.total_currency_amount > 0">
                <label for="refundCurrencyAmount">Amount to Refund</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{ organizationConfigService.getCurrencySymbol() }}</span>
                  </div>
                  <input type="number" min="0" [max]="booking.unrefunded_currency_amount" step="0.01"
                         class="form-control" id="refundCurrencyAmount" name="refundCurrencyAmount"
                         [(ngModel)]="refundCurrencyAmount">
                </div>
              </div>
              <div class="col-6" *ngIf="booking.total_num_vouchers > 0">
                <label for="refundVoucherCount">Vouchers to Refund</label>
                <input type="number" min="0" [max]="booking.unrefunded_num_vouchers" step="1"
                       class="form-control" id="refundVoucherCount" name="refundVoucherCount"
                       [(ngModel)]="refundVoucherCount">
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr>
    </ng-container>

    <!--
      Explain the absence of refund options for a private event whose booking
      has nothing left to refund (no fee was paid, or it was already refunded).
    -->
    <div class="alert alert-info" role="alert"
         *ngIf="isPrivate && !loadingBooking && !hasRefundableAmount()">
      No refund options are shown because this booking has no remaining balance to refund.
    </div>

    <div *ngIf="event.num_reservations > 0">

      <p *ngIf="!isPrivate && (event.schedule_type !== ScheduleType.rolling)">
        If there was a fee associated with reservations attached to this event, they will be automatically refunded once the event is cancelled.
      </p>

      <div class="alert alert-info" role="alert" *ngIf="!isPrivate">
        Individual reservations will be automatically cancelled immediately after the event is cancelled. For events with a large number of reservations, this process may take several minutes.
      </div>

      <div class="form-group">
        <label for="sendCancellationEmails">
          Send Cancellation Notification Emails
        </label>
        <select class="custom-select"
                id="sendCancellationEmails"
                name="sendCancellationEmails"
                [(ngModel)]="sendCancellationEmails">
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>

      <ng-container *ngIf="sendCancellationEmails">

        <p class="mb-2">You may optionally include a message below to send to each cancelled registrant explaining why the reservation was cancelled.</p>

        <div class="form-group">
          <label>Cancellation Email Text</label>
          <app-markdown-editor [id]="'cancellationEmailInput'"
                               [(content)]="cancellationEmailText"></app-markdown-editor>
        </div>

      </ng-container>

    </div>

    <div class="alert alert-danger" role="alert" *ngIf="eventCancellationErrorMessage">
      {{ eventCancellationErrorMessage }}
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="!myAccount.can_manage_events">
      You do not have permission to cancel events.
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Go Back
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!isLoading()"
            [disabled]="!myAccount.can_manage_events"
            [class.disabled]="!myAccount.can_manage_events"
            (click)="onCancelSubmit()">
      Confirm
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="isLoading()">
      Loading...
    </button>
  </div>

</ng-container>
